import { Maybe } from 'gql'
import { Crop } from 'react-image-crop'

export const parseCrop = ({
  cropString,
  image,
  defaultCrop = null,
}: {
  cropString?: Maybe<CropStringType>
  image?: HTMLImageElement
  defaultCrop?: Maybe<Crop>
}): Crop | null => {
  if (!image) return null
  if (!cropString) return defaultCrop
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const [width, height, x, y] = cropString.match(/\d+/g)!
  const [scaleX, scaleY] = imageScale({ image })

  if (fitsWithinImageDimension(image, +width, +height, +x, +y)) {
    return {
      x: +x * scaleX,
      y: +y * scaleY,
      width: +width * scaleX,
      height: +height * scaleY,
      unit: 'px',
    }
  } else {
    return defaultCrop
  }
}

export type CropStringType = `${number}x${number}+${number}+${number}`

export const generateCropString = ({
  crop: { x = 0, y = 0, width = 1, height = 1 },
  image,
}: {
  crop: Crop
  image?: Maybe<HTMLImageElement>
}): CropStringType | null => {
  if (!image) return null

  const [scaleX, scaleY] = imageScale({ image })
  const cropWidth = width / scaleX
  let cropXOffset = x / scaleX

  if (cropWidth + cropXOffset > image.naturalWidth) {
    cropXOffset = image.naturalWidth - cropWidth
  }

  const cropHeight = height / scaleY
  let cropYOffset = y / scaleY

  if (cropHeight + cropYOffset > image.naturalHeight) {
    cropYOffset = image.naturalHeight - cropHeight
  }

  return `${Math.round(cropWidth)}x${Math.round(cropHeight)}+${Math.round(cropXOffset)}+${Math.round(cropYOffset)}`
}

const imageScale = ({ image }: { image: HTMLImageElement }) => [
  image.width / image.naturalWidth,
  image.height / image.naturalHeight,
]

const fitsWithinImageDimension = (
  image: HTMLImageElement,
  width: number,
  height: number,
  x: number,
  y: number
): boolean => {
  return (
    width < image.naturalWidth &&
    height < image.naturalHeight &&
    width / 2 + x < image.naturalWidth &&
    height / 2 + y < image.naturalHeight
  )
}
